module.exports = __webpack_public_path__ + "img/chinesecompany04.e47ac3cb.png";